<template>
  <div>
    <div class="mask" v-if="isShow" @click="close"></div>
    <div class="iphone-x fx-row share" :class="showStyle">
      <!-- 小程序 -->
      <div class="fx-1" @click="shareFriends">好友</div>
      <!-- 朋友圈 -->
      <div class="fx-1" @click="sharePyq">朋友圈</div>
    </div>
  </div>
</template>

<script>
  import env from "@/utils/env";
  //mixin
  import setNavigationRightBtn from "@/mixins/setNavigationRightBtn";
  import setNavigationRightShareBtn from "@/mixins/setNavigationRightShareBtn";
  import shareHelper from "@/mixins/shareHelper";
  import weixinHelper from '@/mixins/weixinHelper';
  //service
  import service from '../../service'

  /*const shareMini = {
    title: '出行如何做好个人防护！哪些东西禁止携带？戳↓',
    background: 'https://cdn.133.cn/gtgjwap/Image/festivalActivity/epidemic/share-mini.png?6',
    xcxUrl: '/mpvuePages/eventsV2/festivalActivity/home/main?choiceIndex=2',
    backUpUrl: 'https://h5.133.cn/gtgjwap/h5/festivalActivity/home'
  }*/

  const sharePyq = {
    title: '出行如何做好个人防护？哪些东西不能带上火车/飞机？点击了解',
    desc: '一定要看！',
    link: 'https://h5.133.cn/gtgjwap/h5/festivalActivity/epidemic',
    imgUrl: 'https://cdn.133.cn/gtgjwap/Image/festivalActivity/epidemic/share-pyq.png'
  }

  export default {
    mixins: [
      setNavigationRightBtn,
      setNavigationRightShareBtn,
      shareHelper,
      weixinHelper
    ],
    methods: {
      shareFriends() {
        //this.shareMiniprogram(shareMini)
        this.shareToWeixin(sharePyq)
        this.close()

        service.eventTrack({eventId: 'epidemic', eventType: 'shareFriends'})
      },
      sharePyq() {
        this.shareToPyq(sharePyq)
        this.close()

        service.eventTrack({eventId: 'epidemic', eventType: 'sharePyq'})
      }
    },
    created() {
      if (env.isNative) {
        this.setNavigationRightShareBtn({icon: "1", callBack: this.show})
      } else if (env.isWeixin) {
        this.weixinShare(sharePyq)
      }
    },
    activated() {
      if (env.isNative) {
        this.setNavigationRightShareBtn({icon: "1", callBack: this.show})
      }
    },
    destroyed() {
      if (env.isNative) {
        this.hideNavigationRightBtn()
      }
    },
    deactivated() {
      if (env.isNative) {
        this.hideNavigationRightBtn()
        this.close()
      }
    }
  };
</script>

<style lang="scss" scoped>
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }

  .share {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    z-index: 999;
    background: #ffffff;
    opacity: 0.9;
    transform: translateY(200px) translateZ(1px);
    transition: transform 0.3s ease-out;
    box-sizing: border-box;
    padding: 20px 0;
    text-align: center;

    &.show {
      transform: translateY(0) translateZ(1px);
    }

    > div {
      box-sizing: border-box;
      padding-top: 40px;
      font-size: 12px;
      position: relative;
    }

    > div:nth-of-type(1) {
      background: url("https://cdn.133.cn/gtgj/icon/smprogram/grabTicket/share/weixin2x.png") center no-repeat;
      background-size: 35px auto;
      background-position: top center;
    }

    > div:nth-of-type(2) {
      background: url("https://cdn.133.cn/gtgj/icon/smprogram/grabTicket/share/moment2x.png") center no-repeat;
      background-size: 35px auto;
      background-position: top center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/projects/festivalActivity/epidemic/pages/components/share.vue